import React, { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { resetPassword } from '../../services/authService';
// import Toast from '../common/Toast';
import { toast } from 'react-toastify';
const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { token } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    try {
      const response = await axios.post(`/api/auth/reset-password/${token}`, {
        password,
      });
      setSuccess('Password has been reset successfully.');
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      setError('Failed to reset password.');
    }
  };

  return (
    <div className='flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900'>
      <div className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md'>
        <h2 className='text-2xl font-bold mb-6 text-gray-900 dark:text-white'>
          Reset Password
        </h2>
        {error && <p className='text-red-500 mb-4'>{error}</p>}
        {success && <p className='text-green-500 mb-4'>{success}</p>}
        <form onSubmit={handleSubmit}>
          <div className='mb-4'>
            <label className='block text-gray-700 dark:text-gray-200'>
              New Password
            </label>
            <input
              type='password'
              className='w-full p-2 border border-gray-300 dark:border-gray-700 rounded mt-1'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className='mb-4'>
            <label className='block text-gray-700 dark:text-gray-200'>
              Confirm Password
            </label>
            <input
              type='password'
              className='w-full p-2 border border-gray-300 dark:border-gray-700 rounded mt-1'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button
            type='submit'
            className='bg-blue-500 dark:bg-blue-700 text-white p-2 rounded hover:bg-blue-600 dark:hover:bg-blue-800'
          >
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
